<template>
  <!-- BEGIN Popup compare cartography -->
  <transition leave-active-class="duration-200">
    <div
      v-show="compareCarto"
      class="z-50 fixed bottom-0 px-4 inset-0 sm:p-0 flex items-center justify-center"
    >
      <!-- Background modal -->
      <transition
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div
          v-if="compareCarto"
          class="fixed inset-0 transition-opacity"
          @click="$emit('close')"
        >
          <div class="absolute inset-0 bg-indigo-600 bg-opacity-85" />
        </div>
      </transition>
      <!-- FIN Background modal -->

      <!-- Content modal -->
      <transition
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100 translate-y-0 sm:scale-100"
        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      >
        <div
          v-if="compareCarto"
          class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-scroll xl:h-full 2xl:h-auto max-h-10/12 shadow-xl transform transition-all sm:w-10/12 sm:p-6"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
        >
          <div
            class="cursor-pointer block absolute right-5 top-5 rounded-full px-2 py-2 bg-pink-100 text-pink-600 border border-pink-600 border-opacity-25 transition ease-in-out duration-500 hover:text-white hover:bg-pink-600"
            @click="$emit('close')"
          >
            <icon name="close" />
          </div>
          <div>
            <h3 class="mt-15 mb-5 w-full">
              Comparer les cartographies
            </h3>
            <!-- BEGIN Content modal -->

            <div
              v-if="cartoToCompare === 'compcle'"
              class="grid grid-cols-12"
            >
              <!-- Historique Compétences clé -->
              <div class="col-span-5">
                <radar
                  v-if="
                    Object.keys(competencesCles).length > 0 &&
                      competencesCles.type == 'multi3'
                  "
                  id-chart="compcleToday"
                  :title="
                    new Date(competencesCles.date_fin_eval) > new Date(0)
                      ? new Date(
                        competencesCles.date_fin_eval
                      ).toLocaleDateString(undefined, options)
                      : 'Aujourd\'hui'
                  "
                  :labels="competencesCles.labels"
                  :values="competencesCles.values"
                  :max="competencesCles.max"
                  :height="250"
                  no-labels
                />
                <pie
                  v-else-if="
                    Object.keys(competencesCles).length > 0 &&
                      competencesCles.type == 'clea'
                  "
                  id-chart="compcleToday"
                  :title="
                    new Date(competencesCles.date_fin_eval) > new Date(0)
                      ? new Date(
                        competencesCles.date_fin_eval
                      ).toLocaleDateString(undefined, options)
                      : 'Aujourd\'hui'
                  "
                  :labels="competencesCles.longLabels"
                  :values="competencesCles.datas"
                  :colors="competencesCles.colors"
                  position-legend="bottom"
                  height="400"
                />
              </div>
              <div class="col-span-5">
                <radar
                  v-if="
                    historyToDisplay >= 0 &&
                      historyCompetencesCles[historyToDisplay].type == 'multi3'
                  "
                  :id-chart="'compcle' + historyToDisplay"
                  :title="
                    new Date(
                      historyCompetencesCles[historyToDisplay].date_fin_eval
                    ).toLocaleDateString(undefined, options)
                  "
                  :labels="historyCompetencesCles[historyToDisplay].labels"
                  :values="historyCompetencesCles[historyToDisplay].values"
                  :max="historyCompetencesCles[historyToDisplay].max"
                  :height="250"
                  no-labels
                />
                <pie
                  v-else-if="
                    historyToDisplay >= 0 &&
                      historyCompetencesCles[historyToDisplay].type == 'clea'
                  "
                  :id-chart="'compcle' + historyToDisplay"
                  :title="
                    new Date(
                      historyCompetencesCles[historyToDisplay].date_fin_eval
                    ).toLocaleDateString(undefined, options)
                  "
                  :labels="historyCompetencesCles[historyToDisplay].longLabels"
                  :values="historyCompetencesCles[historyToDisplay].datas"
                  :colors="historyCompetencesCles[historyToDisplay].colors"
                  position-legend="bottom"
                  height="400"
                />
              </div>
              <div class="col-span-2 px-1/12">
                <h6 class="text-base text-pink-600 text-left py-5 pl-1/6">
                  Historique
                </h6>
                <div
                  v-for="(history, index) in historyCompetencesCles.filter(
                    (h, i) =>
                      !h.disabled &&
                      Object.keys(competencesCles).length > 0 ||
                      i < historyCompetencesCles.length - 1
                  )"
                  :key="index"
                  :class="
                    historyToDisplay == index
                      ? 'bg-gray-300 py-3.5 pl-1/6 cursor-pointer'
                      : 'odd:bg-white bg-opacity-50 odd:bg-opacity-0 hover:bg-gray-300 bg-indigo-100 py-3.5 pl-1/6 cursor-pointer'
                  "
                >
                  <div
                    @click="changeCompare(index)"
                    class="text-left text-base font-normal"
                  >
                    {{
                      new Date(history.date_fin_eval).toLocaleDateString(
                        undefined,
                        options
                      )
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div
              v-else-if="cartoToCompare == 'informatique'"
              class="grid grid-cols-12"
            >
              <!-- Historique Compétences informatique -->
              <div class="col-span-5">
                <radar
                  v-if="
                    Object.keys(competencesInformatique).length > 0 &&
                      competencesInformatique.type == 'multi3'
                  "
                  id-chart="informatiqueToday"
                  :title="
                    new Date(competencesInformatique.date_fin_eval) >
                      new Date(0)
                      ? new Date(
                        competencesInformatique.date_fin_eval
                      ).toLocaleDateString(undefined, options)
                      : 'Aujourd\'hui'
                  "
                  :labels="competencesInformatique.labels"
                  :values="competencesInformatique.values"
                  :max="competencesInformatique.max"
                  :height="250"
                  no-labels
                />

                <pie
                  v-else-if="
                    Object.keys(competencesInformatique).length > 0 &&
                      competencesInformatique.type == 'clea_num'
                  "
                  id-chart="informatiqueToday"
                  :title="
                    new Date(competencesInformatique.date_fin_eval) >
                      new Date(0)
                      ? new Date(
                        competencesInformatique.date_fin_eval
                      ).toLocaleDateString(undefined, options)
                      : 'Aujourd\'hui'
                  "
                  :labels="competencesInformatique.longLabels"
                  :values="competencesInformatique.datas"
                  :colors="competencesInformatique.colors"
                  position-legend="bottom"
                  height="400"
                />
              </div>

              <div class="col-span-5">
                <radar
                  v-if="
                    historyToDisplay >= 0 &&
                      historyCompetencesInformatique[historyToDisplay].type ==
                      'multi3'
                  "
                  :id-chart="'compcle' + historyToDisplay"
                  :title="
                    new Date(
                      historyCompetencesInformatique[
                        historyToDisplay
                      ].date_fin_eval
                    ).toLocaleDateString(undefined, options)
                  "
                  :labels="
                    historyCompetencesInformatique[historyToDisplay].labels
                  "
                  :values="
                    historyCompetencesInformatique[historyToDisplay].values
                  "
                  :max="historyCompetencesInformatique[historyToDisplay].max"
                  :height="250"
                  no-labels
                />
                <pie
                  v-else-if="
                    historyToDisplay >= 0 &&
                      historyCompetencesInformatique[historyToDisplay].type ==
                      'clea_num'
                  "
                  :id-chart="'compcle' + historyToDisplay"
                  :title="
                    new Date(
                      historyCompetencesInformatique[
                        historyToDisplay
                      ].date_fin_eval
                    ).toLocaleDateString(undefined, options)
                  "
                  :labels="
                    historyCompetencesInformatique[historyToDisplay].longLabels
                  "
                  :values="
                    historyCompetencesInformatique[historyToDisplay].datas
                  "
                  :colors="
                    historyCompetencesInformatique[historyToDisplay].colors
                  "
                  position-legend="bottom"
                  height="400"
                />
              </div>
              <div class="col-span-2 px-1/12">
                <h6 class="text-base text-pink-600 text-left py-5 pl-1/6">
                  Historique
                </h6>
                <div
                  v-for="(
                    history, index
                  ) in historyCompetencesInformatique.filter(
                    (h, i) =>
                      !h.disabled &&
                      Object.keys(competencesInformatique).length > 0 ||
                      i < historyCompetencesInformatique.length - 1
                  )"
                  :key="index"
                  :class="
                    historyToDisplay == index
                      ? 'bg-gray-300 py-3.5 pl-1/6 cursor-pointer'
                      : 'odd:bg-white bg-opacity-50 odd:bg-opacity-0 hover:bg-gray-300 bg-indigo-100 py-3.5 pl-1/6 cursor-pointer'
                  "
                >
                  <div
                    v-if="
                      Object.keys(competencesInformatique).length > 0 ||
                        index < historyCompetencesInformatique.length - 1
                    "
                    @click="changeCompare(index)"
                    class="text-left text-base font-normal"
                  >
                    {{
                      new Date(history.date_fin_eval).toLocaleDateString(
                        undefined,
                        options
                      )
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div
              v-else-if="cartoToCompare.includes('linguistique/')"
              class="grid grid-cols-12"
            >
              <!-- Historique Compétences linguistique -->
              <div class="col-span-full justify-self-center text-indigo-600">
                <!-- BEGIN list lang -->
                <div
                  class="flex flex-row self-center relative justify-end items-center cursor-pointer my-2 w-max-content w-max"
                  @click="displayLangueList"
                  @click.stop
                >
                  <div class="flex flex-row ml-auto items-end">
                    <h3 class="text-xl text-indigo-600">
                      {{ langue }}
                    </h3>
                  </div>
                  <div
                    class="text-pink-600 max-h-8 mr-auto rounded-full relative inline-flex items-center p-2 order-2"
                  >
                    <icon
                      v-if="Object.keys(competencesLinguistique).length > 1"
                      class="h-4 w-4"
                      name="chevron-down"
                    />
                  </div>
                  <div
                    class="fieldlist z-20 w-max-content w-max mt-2 absolute rounded-md bg-white flex transform translate-y-full self-end shadow-md shadow-gray-600 text-sm"
                    v-click-outside="hideLangueList"
                    v-if="
                      isLangueListDisplayed &&
                        Object.keys(competencesLinguistique).length > 1
                    "
                  >
                    <div class="mx-5 my-3">
                      <div class="text-left">
                        <div
                          class="first:pt-2 py-1"
                          v-for="(l, i) in Object.keys(competencesLinguistique)"
                          :key="i"
                        >
                          <p
                            class="text-gray-600 hover:text-gray-900"
                            @click.stop="changeLangue(l)"
                          >
                            <span>{{ l }}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- END list lang -->
              </div>
              <div class="col-span-5">
                <radar
                  v-if="
                    competencesLinguistique[langue] &&
                      Object.keys(competencesLinguistique[langue]).length > 0
                  "
                  id-chart="langueToday"
                  :title="
                    new Date(competencesLinguistique[langue].date_fin_eval) >
                      new Date(0)
                      ? new Date(
                        competencesLinguistique[langue].date_fin_eval
                      ).toLocaleDateString(undefined, options)
                      : 'Aujourd\'hui'
                  "
                  :labels="competencesLinguistique[langue].labels"
                  :values="competencesLinguistique[langue].values.value"
                  :max="competencesLinguistique[langue].max"
                  no-labels
                  :height="250"
                />
              </div>

              <div class="col-span-5">
                <radar
                  v-if="historyToDisplay >= 0"
                  :id-chart="'langue' + historyToDisplay"
                  :title="
                    new Date(
                      historyCompetencesLinguistique.filter(
                        (h) => h.langue == langue
                      )[historyToDisplay].date_fin_eval
                    ).toLocaleDateString(undefined, options)
                  "
                  :labels="
                    historyCompetencesLinguistique.filter(
                      (h) => h.langue == langue
                    )[historyToDisplay].labels
                  "
                  :values="
                    historyCompetencesLinguistique.filter(
                      (h) => h.langue == langue
                    )[historyToDisplay].values
                  "
                  :max="
                    historyCompetencesLinguistique.filter(
                      (h) => h.langue == langue
                    )[historyToDisplay].max
                  "
                  :height="250"
                  no-labels
                />
              </div>

              <div class="col-span-2 px-1/12">
                <h6 class="text-base text-pink-600 text-left py-5 pl-1/6">
                  Historique
                </h6>
                <div
                  v-for="(history, index) in (
                    historyCompetencesLinguistique || []
                  )
                    .filter((h) => h.langue == langue)
                    .filter(
                      (h, i) =>
                        !h.disabled &&
                        Object.keys(competencesLinguistique).length > 0 ||
                        i <
                        historyCompetencesLinguistique.filter(
                          (h) => h.langue == langue
                        ).length -
                        1
                    )"
                  :key="index"
                  :class="
                    historyToDisplay == index
                      ? 'bg-gray-300 py-3.5 pl-1/6 cursor-pointer'
                      : 'odd:bg-white bg-opacity-50 odd:bg-opacity-0 hover:bg-gray-300 bg-indigo-100 py-3.5 pl-1/6 cursor-pointer'
                  "
                >
                  <div
                    @click="changeCompare(index)"
                    class="text-left text-base font-normal"
                  >
                    {{
                      new Date(history.date_fin_eval).toLocaleDateString(
                        undefined,
                        options
                      )
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div
              v-else-if="cartoToCompare.includes('sociopro/')"
              class="grid grid-cols-12"
            >
              <!-- Historique Compétences Socio pro -->
              <div
                class="col-span-5"
                v-if="
                  Object.keys(
                    competencesSocioPro[cartoToCompare.split('/')[1]] || {}
                  ).length > 0
                "
              >
                <!-- Case there is a current evaluation -->
                <div
                  v-if="shouldBeSplit(competencesSocioPro[cartoToCompare.split('/')[1]])"
                  class="flex flex-col w-full gap-12"
                >
                  <h2 class="text-xl text-indigo-600 p-9 font-semibold">
                    {{ new Date(
                      competencesSocioPro[
                        cartoToCompare.split('/')[1]
                      ].date_fin_eval
                    ) > new Date(0)
                      ? new Date(
                        competencesSocioPro[
                          cartoToCompare.split('/')[1]
                        ].date_fin_eval
                      ).toLocaleDateString(undefined, options)
                      : 'Aujourd\'hui' }}
                  </h2>
                  <div
                    v-for="[category, current] in getCategories(
                      competencesSocioPro[cartoToCompare.split('/')[1]]
                    )"
                    :key="category"
                  >
                    <h3 class="text-lg">
                      {{ category }}
                    </h3>
                    <radar
                      :height="200"
                      :id-chart="cartoToCompare.split('/')[1] + 'Today' + category"
                      :labels="current.labels"
                      :max="current.max"
                      :values=" current.values.filter(
                        (val) => val.label != 'Référent' || !isBeneficiary
                      )
                      "
                      no-labels
                    />
                  </div>
                </div>
                <div v-else>
                  <radar
                    v-if="
                      Object.keys(
                        competencesSocioPro[cartoToCompare.split('/')[1]] || {}
                      ).length > 0
                    "
                    :id-chart="cartoToCompare.split('/')[1] + 'Today'"
                    :title=" new Date(
                      competencesSocioPro[
                        cartoToCompare.split('/')[1]
                      ].date_fin_eval
                    ) > new Date(0)
                      ? new Date(
                        competencesSocioPro[
                          cartoToCompare.split('/')[1]
                        ].date_fin_eval
                      ).toLocaleDateString(undefined, options)
                      : 'Aujourd\'hui' "
                    :labels="
                      competencesSocioPro[cartoToCompare.split('/')[1]].labels
                    "
                    :values="
                      competencesSocioPro[
                        cartoToCompare.split('/')[1]
                      ].values.filter(
                        (val) => val.label != 'Référent' || !isBeneficiary
                      )
                    "
                    :max="competencesSocioPro[cartoToCompare.split('/')[1]].max"
                    :height="250"
                    no-labels
                  />
                </div>
              </div>

              <div class="col-span-5">
                <div
                  v-if="historyToDisplay >= 0 && shouldBeSplit(historyCompetencesSocioPro[cartoToCompare.split('/')[1]][
                    historyToDisplay
                  ])"
                  class="flex flex-col w-full gap-12"
                >
                  <h2 class="text-xl text-indigo-600 p-9 font-semibold">
                    {{ new Date(
                      historyCompetencesSocioPro[cartoToCompare.split('/')[1]][
                        historyToDisplay
                      ].date_fin_eval
                    ) > new Date(0)
                      ? new Date(
                        historyCompetencesSocioPro[cartoToCompare.split('/')[1]][
                          historyToDisplay
                        ].date_fin_eval
                      ).toLocaleDateString(undefined, options)
                      : 'Aujourd\'hui' }}
                  </h2>
                  <div
                    v-for="[category, current] in getCategories(
                      historyCompetencesSocioPro[cartoToCompare.split('/')[1]][
                        historyToDisplay
                      ]
                    )"
                    :key="category"
                  >
                    <h3 class="text-lg">
                      {{ category }}
                    </h3>
                    <radar
                      :height="200"
                      :id-chart="cartoToCompare.split('/')[1] + historyToDisplay + category"
                      :labels="current.labels"
                      :max="current.max"
                      :values=" current.values.filter(
                        (val) => val.label != 'Référent' || !isBeneficiary
                      )
                      "
                      no-labels
                    />
                  </div>
                </div>
                <div v-else>
                  <radar
                    v-if="historyToDisplay >= 0"
                    :id-chart="cartoToCompare.split('/')[1] + historyToDisplay"
                    :title="
                      new Date(
                        historyCompetencesSocioPro[cartoToCompare.split('/')[1]][
                          historyToDisplay
                        ].date_fin_eval
                      ).toLocaleDateString(undefined, options)
                    "
                    :labels="
                      historyCompetencesSocioPro[cartoToCompare.split('/')[1]][
                        historyToDisplay
                      ].labels
                    "
                    :values="
                      historyCompetencesSocioPro[cartoToCompare.split('/')[1]][
                        historyToDisplay
                      ].values
                    "
                    :max="
                      historyCompetencesSocioPro[cartoToCompare.split('/')[1]][
                        historyToDisplay
                      ].max
                    "
                    :height="250"
                    no-labels
                  />
                </div>
              </div>

              <div class="col-span-2 px-1/12">
                <h6 class="text-base text-pink-600 text-left py-5 pl-1/6">
                  Historique
                </h6>
                <div
                  v-for="(history, index) in historyCompetencesSocioPro[
                    cartoToCompare.split('/')[1]
                  ]"
                  :key="index"
                  :class="
                    historyToDisplay == index
                      ? 'bg-gray-300 py-3.5 pl-1/6 cursor-pointer'
                      : 'odd:bg-white bg-opacity-50 odd:bg-opacity-0 hover:bg-gray-300 bg-indigo-100 py-3.5 pl-1/6 cursor-pointer'
                  "
                >
                  <div
                    @click="changeCompare(index)"
                    class="text-left text-base font-normal"
                  >
                    {{
                      new Date(history.date_fin_eval).toLocaleDateString(
                        undefined,
                        options
                      )
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div
              v-else-if="cartoToCompare.includes('comppro/')"
              class="grid grid-cols-12"
            >
              <!-- Historique Compétences professionnelles -->
              <div class="col-span-5">
                <!-- Case there is a current evaluation -->
                <radar
                  v-if="
                    (competencesPro[cartoToCompare.split('/')[1]] || [])
                      .length > 0
                  "
                  :id-chart="cartoToCompare.split('/')[1] + 'Today'"
                  title="Aujourd'hui"
                  :labels="
                    competencesPro[cartoToCompare.split('/')[1]][
                      cartoToCompare.split('/')[2]
                    ].labels
                  "
                  :values="
                    competencesPro[cartoToCompare.split('/')[1]][
                      cartoToCompare.split('/')[2]
                    ].values.filter(
                      (v) => v.label != 'Référent' || !isBeneficiary
                    )
                  "
                  :max="competencesPro[cartoToCompare.split('/')[1]].max"
                  height="250"
                  no-labels
                />

                <radar
                  v-else-if="
                    historyCompetencesProComputed[cartoToCompare.split('/')[1]].length >
                      0
                  "
                  :id-chart="cartoToCompare.split('/')[1] + 'Today'"
                  :title="
                    new Date(
                      historyCompetencesProComputed[cartoToCompare.split('/')[1]][
                        historyCompetencesProComputed[cartoToCompare.split('/')[1]]
                          .length - 1
                      ][1][cartoToCompare.split('/')[2]].date_fin_eval
                    ).toLocaleDateString(undefined, options)
                  "
                  :labels="
                    historyCompetencesProComputed[cartoToCompare.split('/')[1]][
                      historyCompetencesProComputed[cartoToCompare.split('/')[1]]
                        .length - 1
                    ][1][cartoToCompare.split('/')[2]].labels
                  "
                  :values="
                    historyCompetencesProComputed[cartoToCompare.split('/')[1]][
                      historyCompetencesProComputed[cartoToCompare.split('/')[1]]
                        .length - 1
                    ][1][cartoToCompare.split('/')[2]].values
                  "
                  :max="
                    historyCompetencesProComputed[cartoToCompare.split('/')[1]][
                      historyCompetencesProComputed[cartoToCompare.split('/')[1]]
                        .length - 1
                    ][1][cartoToCompare.split('/')[2]].max
                  "
                  :height="250"
                  no-labels
                />
              </div>

              <div class="col-span-5">
                <radar
                  v-if="historyToDisplay >= 0"
                  :id-chart="cartoToCompare.split('/')[1] + historyToDisplay"
                  :title="
                    new Date(
                      historyCompetencesProComputed[cartoToCompare.split('/')[1]][
                        historyToDisplay
                      ][1][cartoToCompare.split('/')[2]].date_fin_eval
                    ).toLocaleDateString(undefined, options)
                  "
                  :labels="
                    historyCompetencesProComputed[cartoToCompare.split('/')[1]][
                      historyToDisplay
                    ][1][cartoToCompare.split('/')[2]].labels
                  "
                  :values="
                    historyCompetencesProComputed[cartoToCompare.split('/')[1]][
                      historyToDisplay
                    ][1][cartoToCompare.split('/')[2]].values
                  "
                  :max="
                    historyCompetencesProComputed[cartoToCompare.split('/')[1]][
                      historyToDisplay
                    ][1][cartoToCompare.split('/')[2]].max
                  "
                  :height="250"
                  no-labels
                />
              </div>

              <div class="col-span-2 px-1/12">
                <h6 class="text-base text-pink-600 text-left py-5 pl-1/6">
                  Historique
                </h6>
                <div
                  v-for="(history, index) in historyCompetencesProComputed[
                    cartoToCompare.split('/')[1]
                  ].filter(
                    (h, i) =>
                      (competencesPro[cartoToCompare.split('/')[1]] || [])
                        .length > 0 ||
                      i <
                      historyCompetencesProComputed[cartoToCompare.split('/')[1]]
                        .length
                  )"
                  :key="index"
                  :class="
                    historyToDisplay == index
                      ? 'bg-gray-300 py-3.5 pl-1/6 cursor-pointer'
                      : 'bg-indigo-100 odd:bg-white bg-opacity-50 odd:bg-opacity-0 hover:bg-gray-300 py-3.5 pl-1/6 cursor-pointer'
                  "
                >
                  <div
                    @click="changeCompare(index)"
                    class="text-left text-base font-normal"
                  >
                    {{
                      new Date(history[0]).toLocaleDateString(
                        undefined,
                        options
                      )
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div
              v-else-if="cartoToCompare.includes('compproRome/')"
              class="grid grid-cols-12"
            >
              <!-- Historique Compétences professionnelles spécial Fiche ROME -->
              <div class="col-span-5">
                <!-- Case there is a current evaluation -->
                <div
                  v-if="
                    Object.keys(
                      competencesPro[cartoToCompare.split('/')[1]] || {}
                    ).length > 0
                  "
                >
                  <multi-pie
                    :id-chart="
                      'rome' +
                        cartoToCompare.split('/')[2] +
                        cartoToCompare.split('/')[3]
                    "
                    title="Aujourd'hui"
                    :labels="
                      competencesPro[cartoToCompare.split('/')[1]].longLabels
                    "
                    :sub-labels="['Référent', 'Auto-évaluation']"
                    :values="[
                      [
                        competencesPro[cartoToCompare.split('/')[1]].datas[0][
                          cartoToCompare.split('/')[2]
                        ][cartoToCompare.split('/')[3]]['referent'],
                        competencesPro[cartoToCompare.split('/')[1]].datas[1][
                          cartoToCompare.split('/')[2]
                        ][cartoToCompare.split('/')[3]]['referent'],
                      ],
                      [
                        competencesPro[cartoToCompare.split('/')[1]].datas[0][
                          cartoToCompare.split('/')[2]
                        ][cartoToCompare.split('/')[3]]['auto'],
                        competencesPro[cartoToCompare.split('/')[1]].datas[1][
                          cartoToCompare.split('/')[2]
                        ][cartoToCompare.split('/')[3]]['auto'],
                      ],
                      ,
                    ]"
                    :colors="
                      competencesPro[cartoToCompare.split('/')[1]].colors
                    "
                    position-legend="bottom"
                    height="400"
                    thickness="50"
                  />
                </div>

                <div
                  v-else-if="
                    historyCompetencesProComputed[cartoToCompare.split('/')[1]].length >
                      0
                  "
                >
                  <multi-pie
                    :id-chart="
                      'rome' +
                        cartoToCompare.split('/')[2] +
                        cartoToCompare.split('/')[3]
                    "
                    :title="
                      new Date(
                        historyCompetencesProComputed[cartoToCompare.split('/')[1]][
                          historyCompetencesProComputed[cartoToCompare.split('/')[1]]
                            .length - 1
                        ][1].date_fin_eval
                      ).toLocaleDateString(undefined, options)
                    "
                    :labels="
                      historyCompetencesProComputed[cartoToCompare.split('/')[1]][
                        historyCompetencesProComputed[cartoToCompare.split('/')[1]]
                          .length - 1
                      ][1].longLabels
                    "
                    :sub-labels="['Référent', 'Auto-évaluation']"
                    :values="[
                      [
                        historyCompetencesProComputed[cartoToCompare.split('/')[1]][
                          historyCompetencesProComputed[cartoToCompare.split('/')[1]]
                            .length - 1
                        ][1].datas[0][cartoToCompare.split('/')[2]][
                          cartoToCompare.split('/')[3]
                        ]['referent'],
                        historyCompetencesProComputed[cartoToCompare.split('/')[1]][
                          historyCompetencesProComputed[cartoToCompare.split('/')[1]]
                            .length - 1
                        ][1].datas[1][cartoToCompare.split('/')[2]][
                          cartoToCompare.split('/')[3]
                        ]['referent'],
                      ],
                      [
                        historyCompetencesProComputed[cartoToCompare.split('/')[1]][
                          historyCompetencesProComputed[cartoToCompare.split('/')[1]]
                            .length - 1
                        ][1].datas[0][cartoToCompare.split('/')[2]][
                          cartoToCompare.split('/')[3]
                        ]['auto'],
                        historyCompetencesProComputed[cartoToCompare.split('/')[1]][
                          historyCompetencesProComputed[cartoToCompare.split('/')[1]]
                            .length - 1
                        ][1].datas[1][cartoToCompare.split('/')[2]][
                          cartoToCompare.split('/')[3]
                        ]['auto'],
                      ],
                      ,
                    ]"
                    :colors="
                      historyCompetencesProComputed[cartoToCompare.split('/')[1]][
                        historyCompetencesProComputed[cartoToCompare.split('/')[1]]
                          .length - 1
                      ][1].colors
                    "
                    position-legend="bottom"
                    height="400"
                    thickness="50"
                  />
                </div>
              </div>

              <div class="col-span-5">
                <div v-if="historyToDisplay >= 0">
                  <multi-pie
                    :id-chart="
                      'historyrome' +
                        cartoToCompare.split('/')[2] +
                        cartoToCompare.split('/')[3]
                    "
                    :title="
                      new Date(
                        historyCompetencesProComputed[cartoToCompare.split('/')[1]][
                          historyToDisplay
                        ][1].date_fin_eval
                      ).toLocaleDateString(undefined, options)
                    "
                    :labels="
                      historyCompetencesProComputed[cartoToCompare.split('/')[1]][
                        historyToDisplay
                      ][1].longLabels
                    "
                    :sub-labels="['Référent', 'Auto-évaluation']"
                    :values="[
                      [
                        historyCompetencesProComputed[cartoToCompare.split('/')[1]][
                          historyToDisplay
                        ][1].datas[0][cartoToCompare.split('/')[2]][
                          cartoToCompare.split('/')[3]
                        ]['referent'],
                        historyCompetencesProComputed[cartoToCompare.split('/')[1]][
                          historyToDisplay
                        ][1].datas[1][cartoToCompare.split('/')[2]][
                          cartoToCompare.split('/')[3]
                        ]['referent'],
                      ],
                      [
                        historyCompetencesProComputed[cartoToCompare.split('/')[1]][
                          historyToDisplay
                        ][1].datas[0][cartoToCompare.split('/')[2]][
                          cartoToCompare.split('/')[3]
                        ]['auto'],
                        historyCompetencesProComputed[cartoToCompare.split('/')[1]][
                          historyToDisplay
                        ][1].datas[1][cartoToCompare.split('/')[2]][
                          cartoToCompare.split('/')[3]
                        ]['auto'],
                      ],
                      ,
                    ]"
                    :colors="
                      historyCompetencesProComputed[cartoToCompare.split('/')[1]][
                        historyToDisplay
                      ][1].colors
                    "
                    position-legend="bottom"
                    height="400"
                    thickness="50"
                  />
                </div>
              </div>

              <div class="col-span-2 px-1/12">
                <h6 class="text-base text-pink-600 text-left py-5 pl-1/6">
                  Historique
                </h6>
                <div
                  v-for="(history, index) in historyCompetencesProComputed[
                    cartoToCompare.split('/')[1]
                  ].filter(
                    (h, i) =>
                      (competencesPro[cartoToCompare.split('/')[1]] || [])
                        .length > 0 ||
                      Object.keys(
                        competencesPro[cartoToCompare.split('/')[1]] || {}
                      ).length > 0 ||
                      i <
                      historyCompetencesProComputed[cartoToCompare.split('/')[1]]
                        .length -
                      1
                  )"
                  :key="index"
                  :class="
                    historyToDisplay == index
                      ? 'bg-gray-300 py-3.5 pl-1/6 cursor-pointer'
                      : 'bg-indigo-100 odd:bg-white bg-opacity-50 odd:bg-opacity-0 hover:bg-gray-300 py-3.5 pl-1/6 cursor-pointer'
                  "
                >
                  <div
                    @click="changeCompare(index)"
                    class="text-left text-base font-normal"
                  >
                    {{
                      new Date(history[0]).toLocaleDateString(
                        undefined,
                        options
                      )
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div
              v-else-if="cartoToCompare.includes('compsco/')"
              class="grid grid-cols-12"
            >
              <div
                v-if="!cartoToCompare.split('/')[2]"
                class="col-span-full flex justify-center"
              >
                <!-- BEGIN List domaines -->
                <div
                  class="flex flex-row relative justify-end items-center cursor-pointer my-8"
                  style="max-width: 60%"
                  @click="displayFieldModulesScolaireList"
                  @click.stop
                >
                  <div class="flex flex-row ml-auto items-end">
                    <h5 class="text-indigo-600 font-normal">
                      {{ 'Domaine : ' + moduleScolaire }}
                    </h5>
                  </div>
                  <div
                    class="text-pink-600 max-h-8 mr-auto rounded-full relative inline-flex items-center p-2 order-2"
                  >
                    <icon
                      class="h-4 w-4"
                      name="chevron-down"
                    />
                  </div>
                  <div
                    class="fieldlist flex z-20 mt-2 left-16 top-10 w-11/12 absolute rounded-md bg-white shadow-md shadow-gray-600 text-sm"
                    v-click-outside="displayFieldModulesScolaireList"
                    v-if="showModulesScolaireList"
                  >
                    <div class="mx-5 my-3">
                      <div class="text-left">
                        <div
                          class="first:pt-2 py-1"
                          v-for="(libelleMod, imod) in Object.keys(
                            competencesSco[cartoToCompare.split('/')[1]]
                          ).filter((m) => !['labels', 'name_job'].includes(m))"
                          :key="imod"
                        >
                          <p
                            class="text-gray-600 hover:text-gray-900"
                            @click="moduleScolaire = libelleMod"
                          >
                            <span>{{ libelleMod }}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- END List domaines -->
              </div>
              <div
                v-if="cartoToCompare.split('/')[2]"
                class="col-span-full flex justify-center my-5"
              >
                <h5 class="text-indigo-600 font-normal">
                  {{ 'Domaine : ' + moduleScolaire }}
                </h5>
              </div>

              <div class="col-span-full">
                <div class="flex justify-center text-gray-600 cursor-pointer">
                  <div
                    @click="changeTypeCompetenceScolaire('competences')"
                    class="text-2xl inline-block hover:text-pink-600 font-light"
                    :class="{
                      'text-indigo-600 font-normal':
                        typeCompetenceScolaire == 'competences',
                    }"
                  >
                    Compétences
                  </div>
                  <div class="mx-10" />
                  <div
                    @click="
                      changeTypeCompetenceScolaire('competences_transversales')
                    "
                    class="text-2xl inline-block hover:text-pink-600 font-light"
                    :class="{
                      'text-indigo-600 font-normal':
                        typeCompetenceScolaire == 'competences_transversales',
                    }"
                  >
                    Compétences transversales
                  </div>
                </div>
              </div>
              <div class="col-span-5">
                <!-- Case there is a current evaluation -->
                <div
                  v-if="
                    Object.keys(
                      competencesSco[cartoToCompare.split('/')[1]] || {}
                    ).length > 0 && !cartoToCompare.split('/')[2]
                  "
                >
                  <div
                    v-for="(mod, kmod) in competencesSco[
                      cartoToCompare.split('/')[1]
                    ]"
                    :key="kmod"
                  >
                    <bar
                      v-if="
                        Object.keys((mod || {}).module_competences || {})
                          .length > 0 &&
                          typeCompetenceScolaire == 'competences' &&
                          moduleScolaire == kmod
                      "
                      :id-chart="'compscoAutoToday' + kmod + 'competences'"
                      title="Aujourd'hui"
                      orientation="vertical"
                      :thickness="10"
                      height="400"
                      width="400"
                      :stacked="false"
                      :labels="
                        competencesSco[cartoToCompare.split('/')[1]].labels
                      "
                      :values="mod.module_competences"
                      :display-legend="true"
                    />

                    <bar
                      v-if="
                        Object.keys(
                          (mod || {}).module_competences_transversales || {}
                        ).length > 0 &&
                          typeCompetenceScolaire == 'competences_transversales' &&
                          moduleScolaire == kmod
                      "
                      :id-chart="
                        'compscoAutoToday' + kmod + 'competences_transversales'
                      "
                      title="Aujourd'hui"
                      orientation="vertical"
                      :thickness="10"
                      height="400"
                      width="400"
                      :stacked="false"
                      :labels="
                        competencesSco[cartoToCompare.split('/')[1]].labels
                      "
                      :values="mod.module_competences_transversales"
                      :display-legend="true"
                    />
                  </div>
                </div>

                <div
                  v-if="
                    Object.keys(
                      competencesSco[cartoToCompare.split('/')[1]] || {}
                    ).length > 0 && cartoToCompare.split('/')[2]
                  "
                >
                  <div>
                    <bar
                      v-if="
                        (
                          (
                            ((competencesSco || {})[
                              cartoToCompare.split('/')[1]
                            ] || {})[cartoToCompare.split('/')[2]] || {}
                          ).module_competences || []
                        ).length > 0 && typeCompetenceScolaire == 'competences'
                      "
                      :id-chart="'compscoAutoTodaycompetences'"
                      title="Aujourd'hui"
                      orientation="vertical"
                      :thickness="10"
                      height="400"
                      width="400"
                      :stacked="false"
                      :labels="
                        competencesSco[cartoToCompare.split('/')[1]].labels
                      "
                      :values="
                        (
                          ((competencesSco || {})[
                            cartoToCompare.split('/')[1]
                          ] || {})[cartoToCompare.split('/')[2]] || {}
                        ).module_competences || []
                      "
                      :display-legend="true"
                    />
                  </div>
                  <div>
                    <bar
                      v-if="
                        (
                          (
                            ((competencesSco || {})[
                              cartoToCompare.split('/')[1]
                            ] || {})[cartoToCompare.split('/')[2]] || {}
                          ).module_competences_transversales || []
                        ).length > 0 &&
                          typeCompetenceScolaire == 'competences_transversales'
                      "
                      :id-chart="'compscoAutoTodaycompetencestransversales'"
                      title="Aujourd'hui"
                      orientation="vertical"
                      :thickness="10"
                      height="400"
                      width="400"
                      :stacked="false"
                      :labels="
                        competencesSco[cartoToCompare.split('/')[1]].labels
                      "
                      :values="
                        (
                          ((competencesSco || {})[
                            cartoToCompare.split('/')[1]
                          ] || {})[cartoToCompare.split('/')[2]] || {}
                        ).module_competences_transversales || []
                      "
                      :display-legend="true"
                    />
                  </div>
                </div>

                <div
                  v-else-if="
                    (historyCompetencesSco[cartoToCompare.split('/')[1]] || [])
                      .length > 0 && cartoToCompare.split('/')[2]
                  "
                >
                  <div v-if="typeCompetenceScolaire == 'competences'">
                    <bar
                      v-if="
                        (
                          ((((historyCompetencesSco || {})[
                            cartoToCompare.split('/')[1]
                          ] || [])[
                            historyCompetencesSco[cartoToCompare.split('/')[1]]
                              .length - 1
                          ] || [])[1] || {})[cartoToCompare.split('/')[2]] || {}
                        ).module_competences.length > 0
                      "
                      :id-chart="'compscoAutoTodaycompetences'"
                      :title="
                        new Date(
                          historyCompetencesSco[cartoToCompare.split('/')[1]][
                            historyCompetencesSco[cartoToCompare.split('/')[1]]
                              .length - 1
                          ][0]
                        ).toLocaleDateString(undefined, options)
                      "
                      orientation="vertical"
                      :thickness="10"
                      height="400"
                      width="400"
                      :stacked="false"
                      :labels="
                        historyCompetencesSco[cartoToCompare.split('/')[1]][
                          historyCompetencesSco[cartoToCompare.split('/')[1]]
                            .length - 1
                        ][1].labels
                      "
                      :values="
                        (
                          ((((historyCompetencesSco || {})[
                            cartoToCompare.split('/')[1]
                          ] || [])[
                            historyCompetencesSco[cartoToCompare.split('/')[1]]
                              .length - 1
                          ] || [])[1] || {})[cartoToCompare.split('/')[2]] || {}
                        ).module_competences
                      "
                      :display-legend="true"
                    />
                  </div>
                  <div
                    v-if="typeCompetenceScolaire == 'competences_transversales'"
                  >
                    <bar
                      v-if="
                        (
                          ((((historyCompetencesSco || {})[
                            cartoToCompare.split('/')[1]
                          ] || [])[
                            historyCompetencesSco[cartoToCompare.split('/')[1]]
                              .length - 1
                          ] || [])[1] || {})[cartoToCompare.split('/')[2]] || {}
                        ).module_competences_transversales.length > 0
                      "
                      :id-chart="'compscoAutoTodaycompetencestransversales'"
                      :title="
                        new Date(
                          historyCompetencesSco[cartoToCompare.split('/')[1]][
                            historyCompetencesSco[cartoToCompare.split('/')[1]]
                              .length - 1
                          ][0]
                        ).toLocaleDateString(undefined, options)
                      "
                      orientation="vertical"
                      :thickness="10"
                      height="400"
                      width="400"
                      :stacked="false"
                      :labels="
                        historyCompetencesSco[cartoToCompare.split('/')[1]][
                          historyCompetencesSco[cartoToCompare.split('/')[1]]
                            .length - 1
                        ][1].labels
                      "
                      :values="
                        (
                          ((((historyCompetencesSco || {})[
                            cartoToCompare.split('/')[1]
                          ] || [])[
                            historyCompetencesSco[cartoToCompare.split('/')[1]]
                              .length - 1
                          ] || [])[1] || {})[cartoToCompare.split('/')[2]] || {}
                        ).module_competences_transversales
                      "
                      :display-legend="true"
                    />
                  </div>
                </div>
              </div>

              <div class="col-span-5">
                <div
                  v-if="historyToDisplay >= 0 && !cartoToCompare.split('/')[2]"
                >
                  <div
                    v-for="(hmod, khmod) in historyCompetencesSco[
                      cartoToCompare.split('/')[1]
                    ][historyToDisplay][1]"
                    :key="khmod"
                  >
                    <bar
                      v-if="
                        ((hmod || {}).module_competences || []).length > 0 &&
                          typeCompetenceScolaire == 'competences' &&
                          moduleScolaire == khmod
                      "
                      :id-chart="'compscoAutoHistory' + khmod + 'competences'"
                      :title="
                        new Date(
                          historyCompetencesSco[cartoToCompare.split('/')[1]][
                            historyToDisplay
                          ][0]
                        ).toLocaleDateString(undefined, options)
                      "
                      orientation="vertical"
                      :thickness="10"
                      height="400"
                      width="400"
                      :stacked="false"
                      :labels="
                        historyCompetencesSco[cartoToCompare.split('/')[1]][
                          historyToDisplay
                        ][1].labels
                      "
                      :values="hmod.module_competences"
                      :display-legend="true"
                    />

                    <bar
                      v-if="
                        ((hmod || {}).module_competences_transversales || [])
                          .length > 0 &&
                          typeCompetenceScolaire == 'competences_transversales' &&
                          moduleScolaire == khmod
                      "
                      :id-chart="
                        'compscoAutoHistory' +
                          khmod +
                          'competences_transversales'
                      "
                      :title="
                        new Date(
                          historyCompetencesSco[cartoToCompare.split('/')[1]][
                            historyToDisplay
                          ][0]
                        ).toLocaleDateString(undefined, options)
                      "
                      orientation="vertical"
                      :thickness="10"
                      height="400"
                      width="400"
                      :stacked="false"
                      :labels="
                        historyCompetencesSco[cartoToCompare.split('/')[1]][
                          historyToDisplay
                        ][1].labels
                      "
                      :values="hmod.module_competences_transversales"
                      :display-legend="true"
                    />
                  </div>
                </div>

                <div
                  v-if="historyToDisplay >= 0 && cartoToCompare.split('/')[2]"
                >
                  <div v-if="typeCompetenceScolaire == 'competences'">
                    <bar
                      v-if="
                        (
                          ((((historyCompetencesSco || {})[
                            cartoToCompare.split('/')[1]
                          ] || [])[historyToDisplay] || [])[1] || {})[
                            cartoToCompare.split('/')[2]
                          ] || {}
                        ).module_competences.length > 0
                      "
                      :id-chart="'compscoAutoHistorycompetences'"
                      :title="
                        new Date(
                          historyCompetencesSco[cartoToCompare.split('/')[1]][
                            historyToDisplay
                          ][0]
                        ).toLocaleDateString(undefined, options)
                      "
                      orientation="vertical"
                      :thickness="10"
                      height="400"
                      width="400"
                      :stacked="false"
                      :labels="
                        historyCompetencesSco[cartoToCompare.split('/')[1]][
                          historyToDisplay
                        ][1].labels
                      "
                      :values="
                        (
                          ((((historyCompetencesSco || {})[
                            cartoToCompare.split('/')[1]
                          ] || [])[historyToDisplay] || [])[1] || {})[
                            cartoToCompare.split('/')[2]
                          ] || {}
                        ).module_competences
                      "
                      :display-legend="true"
                    />
                  </div>
                  <div
                    v-if="typeCompetenceScolaire == 'competences_transversales'"
                  >
                    <bar
                      v-if="
                        (
                          ((((historyCompetencesSco || {})[
                            cartoToCompare.split('/')[1]
                          ] || [])[historyToDisplay] || [])[1] || {})[
                            cartoToCompare.split('/')[2]
                          ] || {}
                        ).module_competences_transversales.length > 0
                      "
                      :id-chart="'compscoAutoHistorycompetences_transversales'"
                      :title="
                        new Date(
                          historyCompetencesSco[cartoToCompare.split('/')[1]][
                            historyToDisplay
                          ][0]
                        ).toLocaleDateString(undefined, options)
                      "
                      orientation="vertical"
                      :thickness="10"
                      height="400"
                      width="400"
                      :stacked="false"
                      :labels="
                        historyCompetencesSco[cartoToCompare.split('/')[1]][
                          historyToDisplay
                        ][1].labels
                      "
                      :values="
                        (
                          ((((historyCompetencesSco || {})[
                            cartoToCompare.split('/')[1]
                          ] || [])[historyToDisplay] || [])[1] || {})[
                            cartoToCompare.split('/')[2]
                          ] || {}
                        ).module_competences_transversales
                      "
                      :display-legend="true"
                    />
                  </div>
                </div>
              </div>

              <div class="col-span-2 px-1/12">
                <h6 class="text-base text-pink-600 text-left py-5 pl-1/6">
                  Historique
                </h6>
                <div
                  v-for="(history, index) in historyCompetencesSco[
                    cartoToCompare.split('/')[1]
                  ]"
                  :key="index"
                  :class="
                    historyToDisplay == index
                      ? 'bg-gray-300 py-3.5 pl-1/6 cursor-pointer'
                      : 'odd:bg-white bg-opacity-50 odd:bg-opacity-0 hover:bg-gray-300 bg-indigo-100 py-3.5 pl-1/6 cursor-pointer'
                  "
                >
                  <div
                    @click="changeCompare(index)"
                    class="text-left text-base font-normal"
                  >
                    {{
                      new Date(history[0]).toLocaleDateString(
                        undefined,
                        options
                      )
                    }}
                  </div>
                </div>
              </div>
            </div>

            <!-- END Content modal -->
          </div>
        </div>
      </transition>
      <!-- END Content modal -->
    </div>
  </transition>
  <!-- END Popup compare cartography -->
</template>

<script>
import Radar from '../Charts/Radar';
import Pie from '../Charts/Pie';
import MultiPie from '../Charts/MultiPie.vue';
import Bar from '../Charts/Bar';
import Icon from '../Icon';
import ClickOutside from 'vue-click-outside';

export default {
  props: {
    compareCarto: {
      type: Boolean,
      required: true,
    },
    cartoToCompare: {
      type: String,
      required: true,
    },
    historyToDisplay: {
      type: Number,
      required: true,
    },
    competencesCles: {
      type: Object,
      required: false,
      default: () => new Object(),
    },
    historyCompetencesCles: {
      type: Array,
      required: false,
      default: () => [],
    },
    competencesInformatique: {
      type: Object,
      required: false,
      default: () => new Object(),
    },
    historyCompetencesInformatique: {
      type: Array,
      required: false,
      default: () => [],
    },
    competencesLinguistique: {
      type: Object,
      required: false,
      default: () => new Object(),
    },
    historyCompetencesLinguistique: {
      type: Array,
      required: false,
      default: () => [],
    },
    competencesSocioPro: {
      type: Object,
      required: false,
      default: () => new Object(),
    },
    historyCompetencesSocioPro: {
      type: Object,
      required: false,
      default: () => new Object(),
    },
    competencesPro: {
      type: Object,
      required: false,
      default: () => new Object(),
    },
    historyCompetencesPro: {
      type: Object,
      required: false,
      default: () => new Object(),
    },
    competencesSco: {
      type: Object,
      required: false,
      default: () => new Object(),
    },
    historyCompetencesSco: {
      type: Object,
      required: false,
      default: () => new Object(),
    },

    isBeneficiary: {
      type: Boolean,
    },
  },

  components: {
    Icon,
    Radar,
    Pie,
    MultiPie,
    Bar,
  },

  data() {
    return {
      //to format date
      options: { year: 'numeric', month: 'long', day: 'numeric' },

      // datas for niveau langue
      langue: '',
      isLangueListDisplayed: false,

      // datas For Module Scolaire
      moduleScolaire: '',
      typeCompetenceScolaire: 'competences',
      showModulesScolaireList: false,
    };
  },

  mounted() {
    if (
      this.cartoToCompare.includes('compsco/') &&
      !this.cartoToCompare.split('/')[2]
    ) {
      this.moduleScolaire = Object.keys(
        this.competencesSco[this.cartoToCompare.split('/')[1]]
      ).filter((m) => !['labels', 'name_job'].includes(m))[0];
    }
    if (
      this.cartoToCompare.includes('compsco/') &&
      this.cartoToCompare.split('/')[2]
    ) {
      this.moduleScolaire = this.cartoToCompare.split('/')[2];
    }

    if (
      this.cartoToCompare.includes('linguistique/') &&
      this.cartoToCompare.split('/')[2]
    ) {
      this.langue = this.cartoToCompare.split('/')[2];
    }
  },

  methods: {

    shouldBeSplit(carto) {
      return carto.categories.every((cat) => cat.match(/^\d\.\s/));
    },

    getCategories(carto) {
      if (carto.categories.every((cat) => cat.match(/^\d\.\s/))) {
        const sanitized_categories = carto.categories.map((cat) =>
          cat.slice(3)
        );
        const unique_categories = [...new Set(sanitized_categories)];

        const returnValue = [];

        for (const uniqueCategory of unique_categories) {
          let filtered_labels = [];
          let filtered_categories = [];
          let filtered_values = [];
          for (let i = 0; i < sanitized_categories.length; i++) {
            const current_category = sanitized_categories[i];
            if (current_category === uniqueCategory) {
              filtered_labels.push(carto.labels[i]);
              filtered_categories.push(carto.categories[i]);

              for (
                let value_index = 0;
                value_index < carto.values.length;
                value_index++
              ) {
                if (filtered_values[value_index] === undefined) {
                  filtered_values[value_index] = [];
                }
                let current_value = carto.values[value_index];
                filtered_values[value_index].push(current_value.data[i]);
              }
            }
          }

          returnValue.push([
            uniqueCategory,
            {
              ...carto,
              labels: filtered_labels,
              categories: filtered_categories,
              values: carto.values.map((value, index) => {
                return { ...value, data: filtered_values[index] };
              }),
            },
          ]);
        }

        return returnValue;
      } else {
        return [[0, carto]];
      }
    },

    changeCompare(index) {
      this.$emit('changeCompare', index);
    },

    displayFieldModulesScolaireList() {
      this.showModulesScolaireList = !this.showModulesScolaireList;
    },

    changeTypeCompetenceScolaire(type) {
      setTimeout(() => {
        this.typeCompetenceScolaire = '';
      }, 300);
      setTimeout(() => {
        this.typeCompetenceScolaire = type;
      }, 300);
    },

    displayLangueList() {
      this.isLangueListDisplayed = true;
    },

    hideLangueList() {
      this.isLangueListDisplayed = false;
    },

    changeLangue(langue) {
      this.langue = langue;
      this.hideLangueList();
    },
  },

  computed: {
    historyCompetencesProComputed() {
      let result = {};

      for (const poste in this.historyCompetencesPro) {
        let histories = this.historyCompetencesPro[poste];

        histories = histories.sort((a, b) => {
          [a, b] = [new Date(a[0]), new Date(b[0])];
          return a > b;
        });

        if (!this.$subscribed()) {
          result[poste] = histories.filter((hist, index) => index < 1);
        } else {
          result[poste] = histories;
        }
      }

      return result;
    }
  },

  directives: {
    ClickOutside,
  },
};
</script>

<style scoped></style>
